'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@algoacademy/design-system/web/actions/Button';
import { TextDecorator } from '@algoacademy/design-system/web/atoms/TextDecorator';
import { VerticalSpacer } from '@algoacademy/design-system/web/layouts/VerticalSpacer';
import { IllustrationOnTheRightLayout } from '@algoacademy/design-system/web/marketing/layouts/IllustrationOnTheRight';
import { TwoButtonsLayout } from '@algoacademy/design-system/web/marketing/layouts/TwoButtons';
import { H1 } from '@algoacademy/design-system/web/marketing/typography/Heading';
import { P1 } from '@algoacademy/design-system/web/marketing/typography/Paragraph';
import { ScholarshipApplyButton } from '../_forms/ScholarshipApplicationForm';
import { HappyScholarGirl } from '../_svg/HappyScholarGirl';
export function TopSection() {
  const $ = _c(9);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <HappyScholarGirl />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <br />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <H1>Stypendium {t1} <TextDecorator variant="gradient">AlgoAcademy</TextDecorator></H1>;
    t3 = <VerticalSpacer size="content" />;
    t4 = <P1>Nasz program stypendialny powstał z myślą o młodych, ambitnych osobach, które chcą rozwijać swoje umiejętności w dziedzinie informatyki, ale sytuacja finansowa uniemożliwia im dostęp do wysokiej jakości mentoringu.</P1>;
    t5 = <VerticalSpacer size="content" />;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <P1>W ramach stypendium otrzymujesz{" "}<b>całkowicie bezpłatny mentoring projektowy lub rozszerzony</b>, który pomoże Ci zrobić znaczący krok w rozwoju Twojej kariery. Prowadzimy stałą rekrutację - aplikuj już dziś!</P1>;
    t7 = <VerticalSpacer size="button" />;
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <IllustrationOnTheRightLayout illustration={t0}>{t2}{t3}{t4}{t5}{t6}{t7}<TwoButtonsLayout><ScholarshipApplyButton size="xl">Aplikuj o stypendium</ScholarshipApplyButton><Button outline={true} size="xl" href="/regulamin">Szczegóły stypendium</Button></TwoButtonsLayout></IllustrationOnTheRightLayout>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  return t8;
}